<template>
  <div id="container">
    <pay-success class="notfind" title="Your PayPal payment is currently under review. Please wait while the review is completed. During this time, your order will remain unpaid." text="If you prefer not to wait, you may choose an alternative payment method. Once your new payment is successfully processed and your order status is updated, your PayPal payment will be automatically refunded."  />
    
    <div class="btn">
      <el-button class="button" type="primary" :disabled="isdisabled"  @click="PayBack()">{{waitText}}</el-button>
    </div>
  </div>
</template>
<script>
import FZF from "@/components/404.vue";
import PaySuccess from "@/components/paysuccess.vue";
export default {
  name: 'index',
  components: { FZF, PaySuccess },
  data() {
    return {
      isId: '',
      isText: "",
      isdisabled:true,
      seconds: 20,
      waitText:"Please wait, verifying..."
      //?type=paysuccess
      //?type=payerror
      //?type=chpsuccess
      //?type=chperror
      //?type=waresuccess
      //?type=wareerror
      //?type=paypal
      //window.webkit.messageHandlers.(name).postMessage(键值对)
    }
  },
  mounted() {
    window.PayBack = this.PayBack;
    //this.PayBack()
    this.countdown()
  },
  created() {
    //console.log(this.$route.params.id,'this.$route')
    this.isId=this.$route.params.id
    if (this.$route.query.type.indexOf('order') != -1) {
      this.isText = "order"
    } else if (this.$route.query.type.indexOf('chp') != -1) {
      this.isText = 'chp'
    } else if (this.$route.query.type.indexOf('ware') != -1) {
      this.isText = 'ware'
    }
  },
  methods: {
    countdown() {
      let that = this
      that.isdisabled=true
    if (that.seconds > 0) {
        that.waitText=`Please wait, verifying... (${that.seconds}s)`
        that.seconds--;
        setTimeout(function(){
          that.countdown()
        }, 1000); // 1秒后递归调用
    } else {
      that.isdisabled=false
      that.waitText=`Not redirected? Click here.`
      that.PayBack()
    }
    } ,
    PayBack() {
      let that = this
      let ua = navigator.userAgent;
      //android终端
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1|| ua.indexOf('android') > -1|| ua.indexOf('adr') > -1;
      
      //ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? ?CPU.+Mac OS X/); //ios终端
      let data = { "id": this.isId, "type": this.isText }
      if (isiOS) {
        //ios
        console.log(" 我是ios",isiOS)
        //这里是和IOS商量好的写法，调用IOS的finishActivity方法
        try {
          window.webkit.messageHandlers.PayPalCallback.postMessage(data)
        } catch (error) {
          console.log('WKWebView post message');
        }
      } else if(isAndroid){
        //android
        console.log("我是android",JSON.stringify(data));        
        android.PayPalCallback(JSON.stringify(data));           
      }else{
        if(that.isText=='order'){
          that.$router.push({
            path: '/mycardhobby/detail/'+that.isId
          })
        }
        if(that.isText=='ware'){
          that.$router.push({
            path: '/mycardhobby/waredetail/'+that.isId
          })
        }
        if(that.isText=='chp'){
          that.$router.push({
            path: '/mycardhobby/chp'
          })
        }
        console.log("我是其他")
      }
    }
  }
}

</script>
<style scoped>
.btn {
  width: 90%;
  margin: 0 auto;text-align: center;
}
.notfind{
  height: auto !important;
  min-height:300px !important;
  width: 90% !important;
  margin: 0 auto;
}
/* .notfind{
  width: 90%;
  font-size: 16px;
  line-height: 1.2;
  margin-bottom: 10vh;
}
.notfind p{
  width: 60%;
  margin-left: 20%;
} 
.notfind p+p{
  margin-top: 10px;
}*/
.btn a,
.btn .button {
  width: 60%;
  
  margin: 0 auto;
}
#container{
  min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/apppaypal.vue